import application_settings from '../applicationSettings';
import Event from './Event';
import LocalStorage from '../local_data';

class GetCurrentLocation extends Event {
    eventName = 'oms_getCurrentLocation';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for Get current location id
     * @param {string} data.request_id - optional - unique id for request
     * @param {string} data.action - optional - request action
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';

        if (clientId) {

            let currentLocation = new LocalStorage.CurrentLocation(clientId).getData();

            this.onSuccessEvent({
                data: currentLocation
            },  {
                'action' : action, 
                'request_id' : requestId 
            });

        } else {
            //fire error event
            this.onErrorEvent({ "message": "client_id is required", "status": 422 }, {'action' : action, 'request_id' : requestId });
        }
    }
}

export default GetCurrentLocation;